export default __webpack_public_path__ + "static/big-noise-min-80d5ebaca06daa0593ae619365567b8b.png";